angular.module('templates-dist', ['../app/edit/alert.html', '../app/edit/edit.html', '../app/featureinfo/featureinfo.html', '../app/layertree/layertree.html', '../app/map/map.html', '../app/measure/measure.html', '../app/modal/baseInfoModal.html', '../app/modal/cancelModificationsModal.html', '../app/modal/deleteDatasheetModal.html', '../app/modal/deleteGeometryModal.html', '../app/modal/eloirasModal.html', '../app/modal/modalContent.html', '../app/print/print.html', '../app/search/search.html', '../app/sidebar/sidebar_gazdalkodoi.html', '../app/sidebar/sidebar.html']);

angular.module("../app/edit/alert.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/edit/alert.html",
    "<div class=\"alert\" style=\"background-color: #fa39c3; color: white\" role=\"alert\">\n" +
    "  <div ng-transclude></div>\n" +
    "</div>");
}]);

angular.module("../app/edit/edit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/edit/edit.html",
    "<div class=\"pgg-sidebar-item unselectable\">\n" +
    "  <div class=\"pgg-edit\">\n" +
    "    <div>\n" +
    "      <span class=\"pgg-sidebar-item-title\">SZERKESZTÉS</span>\n" +
    "    </div>\n" +
    "    <div class=\"mainButtons-outer\">\n" +
    "      <div class=\"mainButtons-inner-100\">\n" +
    "        <!-- rajzolás gomb  -->\n" +
    "        <a ng-class=\"interactions.draw.getActive() ? 'btn btn-selected pgg-btn-circle' : 'btn btn-primary pgg-btn-circle'\" ng-click=\"ctrl.draw()\" tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.drawNewElement\" tooltip-animation=\"false\" ng-disabled=\"!userCanEdit\"><i class=\"glyphicon glyphicon-plus\"></i></a>\n" +
    "        <!-- elem választás gomb  -->\n" +
    "        <a ng-class=\"interactions.modify.getActive() ? 'btn btn-selected pgg-btn-circle' : 'btn btn-primary pgg-btn-circle'\" ng-click=\"ctrl.modify()\" tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.modifyElement\" tooltip-animation=\"false\"><i class=\"glyphicon glyphicon-edit\"></i></a>\n" +
    "        <div class=\"pgg-float-right\">\n" +
    "          <!-- mentés gomb  -->\n" +
    "          <a ng-disabled=\"!userCanEdit\" ng-class=\"(interactions.modify.getActive() && selectedElements.length > 0\n" +
    "                    && ((editForm.element_name.$dirty && editForm.element_name.$valid) || editForm.eloiras_table.$dirty || editForm.element_geometry.$dirty)\n" +
    "                    && selectedElements[0].valid)\n" +
    "                    ? 'btn btn-default pgg-btn-circle' : 'btn pgg-btn-inactive pgg-btn-circle'\" ng-click=\"(interactions.modify.getActive() && selectedElements.length > 0\n" +
    "                    && (editForm.element_name.$dirty || editForm.eloiras_table.$dirty || editForm.element_geometry.$dirty)\n" +
    "                    && selectedElements[0].valid)\n" +
    "                    ? ctrl.update() : null\" tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.update\" tooltip-animation=\"false\" tooltip-enable=\"editForm.element_name.$dirty || editForm.element_geometry.$dirty\"><i\n" +
    "            class=\"glyphicon glyphicon-ok\"></i></a>\n" +
    "          <!-- mégsem gomb  -->\n" +
    "          <a ng-disabled=\"!userCanEdit\" ng-class=\"(interactions.modify.getActive() && selectedElements.length > 0\n" +
    "                    && (editForm.element_name.$dirty || editForm.eloiras_table.$dirty || editForm.element_geometry.$dirty))\n" +
    "                    ? 'btn btn-default pgg-btn-circle' : 'btn pgg-btn-inactive pgg-btn-circle'\" ng-click=\"(interactions.modify.getActive() && selectedElements.length > 0\n" +
    "                    && (editForm.element_name.$dirty || editForm.eloiras_table.$dirty || editForm.element_geometry.$dirty))\n" +
    "                    ? ctrl.cancel() : null\" tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.cancel\" tooltip-animation=\"false\" tooltip-enable=\"editForm.element_name.$dirty || editForm.element_geometry.$dirty\"><i\n" +
    "            class=\"glyphicon glyphicon-remove\"></i></a>\n" +
    "          <!-- törlés gomb  -->\n" +
    "          <a ng-disabled=\"!userCanEdit\" ng-class=\"interactions.modify.getActive() && selectedElements.length > 0\n" +
    "                    ? 'btn btn-default pgg-btn-circle' : 'btn pgg-btn-inactive pgg-btn-circle'\" ng-click=\"interactions.modify.getActive() && selectedElements.length > 0 ? ctrl.remove('') : null\" tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.removeElement\"\n" +
    "            tooltip-animation=\"false\" tooltip-enable=\"selectedElements.length > 0\"><i class=\"glyphicon glyphicon-trash\"></i></a>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div>\n" +
    "      <hr />\n" +
    "      <div class=\"pgg-help pgg-left5bottom10\" ng-show=\"!(interactions.draw.getActive() || interactions.modify.getActive())\">\n" +
    "        <span>A szerkesztési eszközök segítségével új rajzi elemet vihet fel a térképre, illetve meglévő elemet\n" +
    "          kijelölhet szerkesztésre, módosításra vagy törlésre.</span>\n" +
    "      </div>\n" +
    "      <div class=\"pgg-help pgg-left5bottom10\" ng-show=\"interactions.draw.getActive()\">\n" +
    "        <span>Az egér segítségével új rajzi elemet vihet fel a térképre</span>\n" +
    "      </div>\n" +
    "      <div class=\"pgg-help pgg-left5bottom10\" ng-show=\"interactions.modify.getActive() && selectedElements.length == 0\">\n" +
    "        <span>Kattintással válasszon egy rajzolt elemet!</span>\n" +
    "      </div>\n" +
    "      <div ng-show=\"interactions.draw.getActive()\">\n" +
    "        <div>\n" +
    "          <span class=\"pgg-sidebar-item-title\">Illesztés</span>\n" +
    "          <div class=\"edit-dropdown\">\n" +
    "            <select name=\"snap\" ng-model=\"draw.snap.value\" ng-init=\"draw.snap.value=interactions.snap.getActive()\" ng-options=\"option.value as option.name for option in draw.snap.opts\" ng-change=\"ctrl.toggleSnap(draw.snap.value)\">\n" +
    "            </select>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div>\n" +
    "          <span class=\"pgg-sidebar-item-title\">Felülírás</span>\n" +
    "          <div class=\"edit-dropdown\">\n" +
    "            <select name=\"forced\" ng-model=\"draw.forced.value\" ng-init=\"draw.forced.value=false\" ng-options=\"option.value as option.name for option in draw.forced.opts\">\n" +
    "            </select>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <!--       itt jön a tab -->\n" +
    "      <form name=\"editForm\">\n" +
    "        <uib-tabset active=\"activeTab\" justified=\"true\" ng-show=\"interactions.modify.getActive() && selectedElements.length > 0\">\n" +
    "          <!-- ADATOK -->\n" +
    "          <uib-tab index=\"0\" select=\"tabSelect(0)\" disabled=\"false\" ng-attr-title=\"{{tooltips.mainData}}\">\n" +
    "            <uib-tab-heading>\n" +
    "              <i class=\"glyphicon pgg-glyphicon-tab glyphicon-info-sign\" tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.mainData\" tooltip-animation=\"false\"></i></uib-tab-heading>\n" +
    "            <div class=\"pgg-tabcontent\" ng-show=\"interactions.modify.getActive() && selectedElements.length > 0\" ng-repeat=\"selectedElement in selectedElements\">\n" +
    "              <span class=\"pgg-sidebar-item-title\">Alapadatok</span>\n" +
    "              <div class=\"subcontent\">\n" +
    "                <table class=\"table-striped\">\n" +
    "                  <tbody class=\"pgg-table\">\n" +
    "                    <tr>\n" +
    "                      <td><span>Tábla neve</span></td>\n" +
    "                      <td>\n" +
    "                        <input name=\"element_name\" type=\"text\" ng-model=\"selectedElement.name\" placeholder=\"Tábla neve...\" ng-disabled=\"!userCanEdit\" ng-required=\"true\" ng-maxlength=\"30\">\n" +
    "                        <div ng-show=\"editForm.element_name.$dirty && editForm.element_name.$invalid\" class=\"invalid pgg-smaller pgg-error-paddingtop\">\n" +
    "                          <span ng-show=\"editForm.element_name.$error.required\">Kötelező mező.</span>\n" +
    "                          <span ng-show=\"editForm.element_name.$error.maxlength\">A tábla neve legfeljebb 30 karakter hosszú lehet.</span>\n" +
    "                        </div>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"selectedElement.properties.created_at\">\n" +
    "                      <td><span>Létrehozva</span></td>\n" +
    "                      <td><span ng-bind=\"selectedElement.properties.created_at | date:'yyyy-MM-dd HH:mm:ss'\"></span></td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"selectedElement.properties.updated_at\">\n" +
    "                      <td><span>Utolsó módosítás</span></td>\n" +
    "                      <td><span ng-bind=\"selectedElement.properties.updated_at | date:'yyyy-MM-dd HH:mm:ss'\"></span></td>\n" +
    "                    </tr>\n" +
    "                  </tbody>\n" +
    "                </table>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </uib-tab>\n" +
    "          <!-- ADATLAPOK -->\n" +
    "          <uib-tab index=\"1\" select=\"tabSelect(1)\" disabled=\"false\" ng-attr-title=\"{{tooltips.datasheets}}\">\n" +
    "            <uib-tab-heading> <i class=\"glyphicon pgg-glyphicon-tab glyphicon-file\" tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.datasheets\" tooltip-animation=\"false\"></i></uib-tab-heading>\n" +
    "            <div ng-repeat=\"selectedElement in selectedElements\" class=\"pgg-tabcontent\">\n" +
    "              <span class=\"pgg-sidebar-item-title\">Adatlapok</span>\n" +
    "              <div class=\"subcontent\">\n" +
    "                <div class=\"pgg-help\" ng-show=\"selectedElement.datasheets == null || selectedElement.datasheets.length == 0\">A kiválasztott táblához még nem tartozik adatlap.</div>\n" +
    "                <table class=\"table-striped pgg-table\">\n" +
    "                  <tr ng-repeat=\"datasheet in selectedElement.datasheets | orderBy: ['-handled_year', 'agronomist_area_name']\">\n" +
    "                    <td><span>{{datasheet.agronomist_area_name}}</span><span class=\"datasheet-icons\">\n" +
    "                    <span>\n" +
    "                      <i class=\"glyphicon pgg-glyphicon glyphicon-file cursor-pointer\" tooltip-placement=\"top\"\n" +
    "                        uib-tooltip-html=\"tooltips.showDatasheet\" tooltip-animation=\"false\"\n" +
    "                        ng-click=\"openDatasheet('', datasheet)\"></i>\n" +
    "                    </span>\n" +
    "                      <span ng-show=\"userCanEdit\">\n" +
    "                      <i class=\"glyphicon pgg-glyphicon glyphicon-trash cursor-pointer\" tooltip-placement=\"top\"\n" +
    "                        uib-tooltip-html=\"tooltips.showRemoveDatasheet\" tooltip-animation=\"false\"\n" +
    "                        ng-click=\"deleteDatasheet('', datasheet)\"></i>\n" +
    "                    </span>\n" +
    "                      </span>\n" +
    "                      <div class=\"datasheet-plusinfo pgg-help pgg-plusinfo\">\n" +
    "                        <span>{{datasheet.handled_year}} ({{selectedElement.name}})</span>\n" +
    "                      </div>\n" +
    "                    </td>\n" +
    "                  </tr>\n" +
    "                </table>\n" +
    "                <hr class=\"hr10px\" />\n" +
    "                <span class=\"cursor-pointer\" ng-click=\"openDatasheet('', {})\" ng-show=\"userCanEdit\">\n" +
    "              <i class=\"glyphicon glyphicon-plus\"></i>&nbsp;Új adatlap feltöltése\n" +
    "            </span>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </uib-tab>\n" +
    "          <!-- ELŐÍRÁSOK -->\n" +
    "          <uib-tab index=\"2\" select=\"tabSelect(2)\" disabled=\"false\" ng-attr-title=\"{{tooltips.restrictions}}\">\n" +
    "            <uib-tab-heading>\n" +
    "              <i class=\"glyphicon pgg-glyphicon-tab glyphicon-tags\" tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.restrictions\" tooltip-animation=\"false\"></i></uib-tab-heading>\n" +
    "            <div ng-repeat=\"selectedElement in selectedElements\" class=\"pgg-tabcontent\">\n" +
    "              <span class=\"pgg-sidebar-item-title\">Előírások</span>\n" +
    "              <div class=\"subcontent\">\n" +
    "                <input ng-show=\"false\" type=\"text\" name=\"eloiras_table\" ng-model=\"eloiras_table_dirty\">\n" +
    "                <div class=\"pgg-help pgg-left5bottom10\">\n" +
    "                  <span ng-show=\"selectedElement.eloirasok == null\">Előírások lekérése, kérem várjon...</span>\n" +
    "                  <span ng-show=\"selectedElement.eloirasok.length == 0 \">A területhez nem tartoznak kezelési\n" +
    "                előírások.</span>\n" +
    "                  <span ng-show=\"selectedElement.eloirasok.length > 0 \">A kezelési egységek szerint csoportosított\n" +
    "                előírások a kezelési egység nevére vagy a nyílra kattintva tekinthetők meg. A kezelési egység fölé\n" +
    "                mozgatva az egeret az a térképen láthatóvá is válik. Majd kattintson a kezelési előírásokra, és értékelje egyenként.</span>\n" +
    "                </div>\n" +
    "                <uib-accordion close-others=\"true\">\n" +
    "                  <uib-accordion-group is-open=\"status.open\" ng-repeat=\"kezelesiEgyseg in selectedElement.eloirasok | orderBy: ['-geojson.properties.area_ha_per', 'ke_kod']\">\n" +
    "                    <uib-accordion-heading>\n" +
    "                      <div ng-mouseover=\"showHoverLayer(kezelesiEgyseg)\" ng-mouseout=\"hideHoverLayer()\">\n" +
    "                        <div>\n" +
    "                          <span class=\"ke-kod\">{{kezelesiEgyseg.ke_kod}}</span>\n" +
    "                          <span class=\"terulet-meret\">{{kezelesiEgyseg.geojson.properties.area_ha_abs}} ha ({{kezelesiEgyseg.geojson.properties.area_ha_per}}%)</span>\n" +
    "                          <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': status.open, 'glyphicon-chevron-right': !status.open}\"></i>\n" +
    "                        </div>\n" +
    "                        <div>\n" +
    "                          <span class=\"pgg-plusinfo\">{{kezelesiEgyseg.ke_nev}}</span>\n" +
    "                        </div>\n" +
    "                        <div>\n" +
    "                          <div class=\"pgg-plusinfo\">\n" +
    "                            <span>Értékelt előírások:</span>\n" +
    "                            <span ng-style=\"styleByPercent(kezelesiEgyseg.ertekelt, kezelesiEgyseg.children)\">{{kezelesiEgyseg.ertekelt.length}}/{{kezelesiEgyseg.children.length}} ({{calculatePercent(kezelesiEgyseg.ertekelt, kezelesiEgyseg.children)}}%)</span>\n" +
    "                          </div>\n" +
    "                        </div>\n" +
    "                      </div>\n" +
    "                    </uib-accordion-heading>\n" +
    "                    <table class=\"table-striped table-responsive pgg-table fixedTable cursor-pointer\">\n" +
    "                      <thead>\n" +
    "                      </thead>\n" +
    "                      <tbody>\n" +
    "                        <tr ng-repeat=\"eloiras in kezelesiEgyseg.children\" ng-style=\"{'background-color': eloirasStyleFunction(eloiras, eloirasOptions)}\" ng-click=\"openEloirasModal('', kezelesiEgyseg, eloiras)\">\n" +
    "                          <td><span>{{eloiras.description}}</span></td>\n" +
    "                        </tr>\n" +
    "                      </tbody>\n" +
    "                    </table>\n" +
    "                  </uib-accordion-group>\n" +
    "                </uib-accordion>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </uib-tab>\n" +
    "          <!-- GEOMETRIA -->\n" +
    "          <uib-tab index=\"3\" select=\"tabSelect(3)\" disabled=\"false\" ng-attr-title=\"{{tooltips.geometry}}\">\n" +
    "            <uib-tab-heading> <i class=\"glyphicon pgg-glyphicon-tab glyphicon-globe\" tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.geometry\" tooltip-animation=\"false\"></i></uib-tab-heading>\n" +
    "            <div class=\"pgg-tabcontent\" ng-show=\"interactions.draw.getActive() || (interactions.modify.getActive() && selectedElements.length > 0)\">\n" +
    "              <div>\n" +
    "                <span class=\"pgg-sidebar-item-title\">Illesztés</span>\n" +
    "                <div class=\"edit-dropdown\">\n" +
    "                  <select name=\"snap\" ng-model=\"draw.snap.value\" ng-init=\"draw.snap.value=interactions.snap.getActive()\" ng-options=\"option.value as option.name for option in draw.snap.opts\" ng-change=\"ctrl.toggleSnap(draw.snap.value)\">\n" +
    "                  </select>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "              <div>\n" +
    "                <span class=\"pgg-sidebar-item-title\">Felülírás</span>\n" +
    "                <div class=\"edit-dropdown\">\n" +
    "                  <select name=\"forced\" ng-model=\"draw.forced.value\" ng-init=\"draw.forced.value=false\" ng-options=\"option.value as option.name for option in draw.forced.opts\">\n" +
    "                  </select>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "              <div ng-show=\"selectedElements.length > 0 && userCanEdit\">\n" +
    "                <span class=\"pgg-sidebar-item-title\">Belső terület kivágása</span>\n" +
    "                <input class=\"cursor-pointer\" type=\"checkbox\" ng-model=\"innerRing.checked\" ng-checked=\"innerRing.checked\" ng-change=\"ctrl.toggleHoleDraw()\">\n" +
    "              </div>\n" +
    "              <div ng-show=\"false\">\n" +
    "                <input type=\"text\" name=\"element_geometry\" ng-model=\"selectedElements[0].geometry\">\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </uib-tab>\n" +
    "        </uib-tabset>\n" +
    "      </form>\n" +
    "      <div class=\"pgg-alerts\">\n" +
    "        <uib-alert ng-repeat=\"alert in alerts\" type=\"{{alert.type}}\" close=\"closeAlert($index)\" dismiss-on-timeout=\"3000\">{{alert.msg}}</uib-alert>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("../app/featureinfo/featureinfo.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/featureinfo/featureinfo.html",
    "<div class=\"pgg-sidebar-item unselectable\">\n" +
    "  <div class=\"pgg-featureinfo\">\n" +
    "    <div>\n" +
    "      <span class=\"pgg-sidebar-item-title\">ELEM LEKÉRDEZÉS</span>\n" +
    "      <!-- PLUSZ INFÓ -->\n" +
    "      <div class=\"pgg-help pgg-left5bottom10\">\n" +
    "        <span ng-show=\"!layers.selected\">Válasszon réteget a legördülő menüből!</span>\n" +
    "        <span ng-show=\"layers.selected\">Kattintson a térképre elem lekérdezéshez!</span>\n" +
    "      </div>\n" +
    "      <!-- RÉTEGVÁLASZTÓ -->\n" +
    "      <div class=\"pgg-layerselect\">\n" +
    "        <ui-select ng-model=\"layers.selected\" theme=\"selectize\" title=\"Válassza ki a réteget\"\n" +
    "          on-select=\"activateToolWithLayer()\"> <ui-select-match placeholder=\"Válassza ki a réteget...\">{{$select.selected.value}}</ui-select-match>\n" +
    "        <ui-select-choices repeat=\"item in layers | filter: $select.search\">\n" +
    "        <div ng-bind-html=\"item.value | highlight: $select.search\"></div>\n" +
    "        </ui-select-choices> </ui-select>\n" +
    "      </div>\n" +
    "      <!-- FEATUREINFO TÁBLÁZAT -->\n" +
    "      <div ng-show=\"nofeatures\">\n" +
    "        <span class=\"pgg-help pgg-left5bottom10\">Nincs találat.</span>\n" +
    "      </div>\n" +
    "      <div ng-show=\"elements.length > 0\">\n" +
    "        <table ng-repeat=\"element in elements\" class=\"table-striped pgg-featureinfotable table-responsive fixedTable\">\n" +
    "          <tbody class=\"pgg-table\">\n" +
    "            <tr ng-repeat=\"(key, value) in element\">\n" +
    "              <td class=\"mediumColumn\">{{key}}</td>\n" +
    "              <td>{{value}}</td>\n" +
    "            </tr>\n" +
    "          </tbody>\n" +
    "        </table>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("../app/layertree/layertree.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/layertree/layertree.html",
    "<div class=\"pgg-sidebar-item unselectable\">\n" +
    "  <div class=\"pgg-layertree\">\n" +
    "    <div ng-repeat=\"layergroup in layergroups\" class=\"layergroup\">\n" +
    "      <div class=\"pgg-sidebar-item-title\">\n" +
    "        <span class=\"cursor-pointer\" ng-click=\"ctrl.toggleExpand(layergroup)\">{{layergroup.label | uppercase}}</span>\n" +
    "        <div class=\"layer layerVisible\" ng-class=\"layer.visible ? 'layer-visible-bg' : ''\" ng-repeat=\"layer in (orderedLayers = (layergroup.data | orderBy : '-zIndex'))\" ng-show=\"layergroup.visible\">\n" +
    "          <ul>\n" +
    "            <li>\n" +
    "              <div>\n" +
    "                <!-- Réteg láthatóság ikon -->\n" +
    "                <span tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.visibility\" tooltip-animation=\"false\">\n" +
    "                <i ng-class=\"layer.visible ? 'fa fa-eye cursor-pointer layer-visible' : 'fa fa-eye-slash cursor-pointer'\" \n" +
    "                    ng-click=\"ctrl.toggleVisibility(layer)\"></i>\n" +
    "                </span>\n" +
    "                <!-- Réteg átlátszóság ikon -->\n" +
    "                <span tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.opacity\" tooltip-animation=\"false\">\n" +
    "                <i class=\"fa fa-signal cursor-pointer\" \n" +
    "                    ng-click=\"ctrl.toggleOpacity(layer)\"></i>\n" +
    "                </span>\n" +
    "                <!-- Réteg jelmagyarázat ikon -->\n" +
    "                <span tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.legend\" tooltip-animation=\"false\">\n" +
    "                <i class=\"fa fa-paint-brush cursor-pointer\" \n" +
    "                    ng-if=\"layer.get('legendGraphic')\" ng-click=\"ctrl.toggleLegend(layer)\"></i>\n" +
    "                </span>\n" +
    "                <!-- Réteg neve -->\n" +
    "                <span ng-click=\"ctrl.toggleVisibility(layer)\" class=\"layername cursor-pointer\">{{layer.get(\"name\")}}</span>\n" +
    "                <!-- Réteg mozgatása -->\n" +
    "                <span ng-show=\"!layer.get('baseLayer')\">\n" +
    "                  <span class=\"arrows\" ng-show=\"$index < layergroup.data.length-1\" tooltip-placement=\"left\"\n" +
    "                    uib-tooltip-html=\"tooltips.moveDown\" tooltip-animation=\"false\">\n" +
    "                    <i class=\"glyphicon glyphicon-menu-down cursor-pointer\"\n" +
    "                      ng-click=\"ctrl.moveLayer(layer, orderedLayers[$index + 1])\"></i>\n" +
    "                  </span>\n" +
    "                <span class=\"arrows\" ng-show=\"$index!=0\" tooltip-placement=\"left\" uib-tooltip-html=\"tooltips.moveUp\" tooltip-animation=\"false\">\n" +
    "                    <i class=\"glyphicon glyphicon-menu-up cursor-pointer\"\n" +
    "                      ng-click=\"ctrl.moveLayer(layer, orderedLayers[$index - 1])\"></i>\n" +
    "                  </span>\n" +
    "                </span>\n" +
    "              </div>\n" +
    "              <div class=\"additional-info\">\n" +
    "                <!-- Réteg láthatóság csúszka -->\n" +
    "                <div ng-show=\"layer.showOpacity\">\n" +
    "                  <input id=\"range\" type=\"range\" min=\"0\" max=\"1\" step=\"0.05\" ng-model=\"layer.opacity\" />\n" +
    "                </div>\n" +
    "                <!-- Réteg jelmagyarázat kép -->\n" +
    "                <div ng-show=\"layer.showLegend\">\n" +
    "                  <div ng-if=\"layer.get('legendGraphic')\" ng-repeat=\"a in layer.getSource().getParams().LAYERS.split(',')\">\n" +
    "                    <img ng-src=\"{{ctrl.getLegendGraphicUrl(layer, $index)}}\">\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "          <hr />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("../app/map/map.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/map/map.html",
    "<div ngeo-map=\"ctrl.map\"></div>");
}]);

angular.module("../app/measure/measure.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/measure/measure.html",
    "<div class=\"pgg-sidebar-item unselectable\">\n" +
    "  <div class=\"pgg-measure\">\n" +
    "    <span class=\"pgg-sidebar-item-title\">TÁVOLSÁG- ÉS TERÜLETMÉRÉS</span>\n" +
    "    <div class=\"mainButtons-outer\">\n" +
    "      <!-- hossz -->\n" +
    "      <a ngeo-btn class=\"btn btn-primary pgg-btn-circle pgg-measure-icon\" ng-model=\"ctrl.measureLength.active\"\n" +
    "        ng-click=\"ctrl.toggleMeasureLength()\" tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.measureLength\"\n" +
    "        tooltip-animation=\"false\"><img ng-src=\"assets/terkep/img/icon-measure-length_30px.png\"\n" +
    "          class=\"cursor-pointer\"></a>\n" +
    "      <!-- terület -->\n" +
    "      <a ngeo-btn class=\"btn btn-primary pgg-btn-circle pgg-measure-icon\" ng-model=\"ctrl.measureArea.active\"\n" +
    "        ng-click=\"ctrl.toggleMeasureArea()\" tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.measureArea\"\n" +
    "        tooltip-animation=\"false\"><img ng-src=\"assets/terkep/img/icon-measure-area_30px.png\" class=\"cursor-pointer\"></a>\n" +
    "      <!-- azimut -->\n" +
    "      <a ngeo-btn class=\"btn btn-primary pgg-btn-circle pgg-measure-icon\" ng-model=\"ctrl.measureAzimut.active\"\n" +
    "        ng-click=\"ctrl.toggleMeasureAzimut()\" tooltip-placement=\"top\" uib-tooltip-html=\"tooltips.measureAzimuth\"\n" +
    "        tooltip-animation=\"false\"><img ng-src=\"assets/terkep/img/icon-measure-azimuth_30px.png\"\n" +
    "          class=\"cursor-pointer\"></a>\n" +
    "    </div>\n" +
    "    <hr />\n" +
    "    <div class=\"pgg-help pgg-left5bottom10\" ng-show=\"true\">\n" +
    "      <span>A mérési eszközök segítségével hosszat, területet és szöget mérhet a térképen.</span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/modal/baseInfoModal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/modal/baseInfoModal.html",
    "<div class=\"pgg-modal\">\n" +
    "  <div class=\"modal-header\">\n" +
    "    <h3 class=\"modal-title\">Tábla elnevezése</h3>\n" +
    "  </div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <div>\n" +
    "      <span>Kérem nevezze el a gazdálkodói táblát!</span>\n" +
    "    </div>\n" +
    "    <form name=\"nameForm\">\n" +
    "      <input class=\"nameInput\"\n" +
    "          type=\"text\"\n" +
    "          name=\"name\"\n" +
    "          placeholder=\"Név...\"\n" +
    "          ng-model=\"name\"\n" +
    "          ng-required=\"true\"\n" +
    "          ng-maxlength=\"30\"\n" +
    "          ng-focus=\"true\">\n" +
    "      <div ng-show=\"nameForm.name.$dirty && nameForm.name.$invalid\"\n" +
    "          class=\"invalid pgg-smaller pgg-error-paddingtop\">\n" +
    "        <span ng-show=\"nameForm.name.$error.required\">Kötelező mező.</span>\n" +
    "        <span ng-show=\"nameForm.name.$error.maxlength\">A tábla neve legfeljebb 30 karakter hosszú lehet.</span>\n" +
    "      </div>\n" +
    "    </form>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\"\n" +
    "        type=\"button\"\n" +
    "        ng-disabled=\"nameForm.$invalid\"\n" +
    "        ng-click=\"ok()\">OK</button>\n" +
    "    <button class=\"btn btn-warning\"\n" +
    "        type=\"button\"\n" +
    "        ng-click=\"cancel()\">Mégsem</button>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/modal/cancelModificationsModal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/modal/cancelModificationsModal.html",
    "<div class=\"modal-header\">\n" +
    "  <h3 class=\"modal-title\">Nem mentett módosítások</h3>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "  <div>\n" +
    "    <span>Még nem mentett el minden módosítást. Kívánja most menteni?</span>\n" +
    "  </div>\n" +
    "  <div ng-show=\"!isValid\">\n" +
    "    <br />\n" +
    "    <span class=\"invalid glyphicon glyphicon-ban-circle\"></span>\n" +
    "    <span class=\"invalid pgg-modal-error\">Úgy tűnik, a mentendő geometria helytelen! Csak abban az esetben van\n" +
    "      lehetőség az \"Igen\" gombra kattintásra, amennyiben helyes geometriák kerülnének elmentésre.</span>\n" +
    "  </div>\n" +
    "  <div>\n" +
    "    <br />\n" +
    "    <span class=\"pgg-plusinfo glyphicon glyphicon-warning-sign\"></span>\n" +
    "    <span class=\"pgg-plusinfo\">Amennyiben a \"Nem\"-et választja, az el nem mentett módosítások elvesznek.</span>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "  <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!(isValid && userCanEdit)\" ng-click=\"ok()\">Igen</button>\n" +
    "  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Nem</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/modal/deleteDatasheetModal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/modal/deleteDatasheetModal.html",
    "<div class=\"modal-header\">\n" +
    "  <h3 class=\"modal-title\">Adatlap törlése</h3>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">Biztos benne, hogy törölni kívánja az adatlapot, és az ahhoz kapcsolódó kezelési előírásokat?</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">Igen</button>\n" +
    "  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Mégsem</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/modal/deleteGeometryModal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/modal/deleteGeometryModal.html",
    "<div class=\"modal-header\">\n" +
    "  <h3 class=\"modal-title\">Elem törlése</h3>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">Biztos benne, hogy törölni kívánja a kiválasztott elemet, és az ahhoz kapcsolódó összes\n" +
    "  adatot?</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">Igen</button>\n" +
    "  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Mégsem</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/modal/eloirasModal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/modal/eloirasModal.html",
    "<div class=\"pgg-modal\">\n" +
    "  <div class=\"modal-header\">\n" +
    "    <h3 class=\"modal-title\">{{kezelesiEgyseg.ke_nev}} - {{currentPage}}/{{totalItems}}</h3>\n" +
    "    <span class=\"pgg-help pgg-plusinfo\">Módosíthatja, hogy a területre alkalmazható előírások milyen mértékben\n" +
    "    vonatkoznak az Ön által berajzolt gazdálkodói táblára. Ezek az értékek a későbbiekben tetszőlegesen módosíthatók.</span>\n" +
    "  </div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <div ng-repeat=\"row in kezelesiEgyseg.children.slice(((currentPage-1)*itemsPerPage), ((currentPage)*itemsPerPage))\">\n" +
    "      <div class=\"eloiras pgg-left20right20\">\n" +
    "        <div>\n" +
    "          <span class=\"rule_id\">{{row.rule_id}}:</span>\n" +
    "        </div>\n" +
    "        <span>{{row.description}}</span>\n" +
    "      </div>\n" +
    "      <hr />\n" +
    "      <span class=\"eloiras-question\">\n" +
    "      <b>Mennyire ért egyet az előírással?</b>\n" +
    "    </span>\n" +
    "      <br />\n" +
    "      <br />\n" +
    "      <div class=\"pgg-left20right20\">\n" +
    "        <form ng-submit=\"submit()\" class=\"bidi\" ng-cloak>\n" +
    "          <md-radio-group ng-model=\"row.selectedEloirasId\">\n" +
    "            <md-radio-button ng-repeat=\"option in options | orderBy: 'id'\" ng-value=\"option.id\" class=\"md-primary\" ng-disabled=\"!userCanEdit\" ng-style=\"styleFunction(option, row.selectedEloirasId)\">\n" +
    "              <span>{{option.value}}</span>\n" +
    "            </md-radio-button>\n" +
    "          </md-radio-group>\n" +
    "        </form>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <uib-pager total-items=\"totalItems\" ng-model=\"currentPage\" items-per-page=\"itemsPerPage\" previous-text=\"Előző\" next-text=\"Következő\"></uib-pager>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\" ng-disabled=\"!userCanEdit\">Mentés és bezárás</button>\n" +
    "    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Mégsem</button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("../app/modal/modalContent.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/modal/modalContent.html",
    "<div class=\"modal-header\">\n" +
    "  <h3 class=\"modal-title\">\n" +
    "    <span>{{adatlap.name}}</span>\n" +
    "    <span> - </span>\n" +
    "    <span ng-if=\"adatlap.id === null\">ÚJ </span>\n" +
    "    <span>ADATLAP</span></h3>\n" +
    "  <span class=\"pgg-help\">\n" +
    "    A csillaggal (\n" +
    "    <span class=\"pgg-asterisk\">*</span> ) megjelölt mezők kitöltése kötelező.\n" +
    "  </span>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "  <form name=\"adatlapForm\" class=\"pgg-modal\">\n" +
    "    <table class=\"pgg-table fixedTable\">\n" +
    "      <tr ng-class=\"((adatlapForm.agronomist_area_name.$pristine && adatlap.agronomist_area_name.value === null) \n" +
    "        || (adatlapForm.agronomist_area_name.$dirty && adatlapForm.agronomist_area_name.$invalid)) ? 'required' : ''\">\n" +
    "        <td><span class=\"pgg-bold\">{{fields.agronomist_area_name}}</span> <span class=\"pgg-asterisk\">*</span></td>\n" +
    "        <td>\n" +
    "          <input type=\"text\" name=\"agronomist_area_name\" ng-model=\"adatlap.agronomist_area_name.value\" ng-required=\"true\" title=\"Nevezze el az adatlapot\" placeholder=\"Nevezze el az adatlapot\" ng-disabled=\"!userCanEdit\" ng-maxlength=\"30\">\n" +
    "          <div class=\"invalid pgg-smaller pgg-error-paddingtop\" ng-show=\"adatlapForm.agronomist_area_name.$dirty && adatlapForm.agronomist_area_name.$invalid\">\n" +
    "            <span ng-if=\"adatlapForm.agronomist_area_name.$error.required\">Kötelező mező</span>\n" +
    "            <span ng-if=\"adatlapForm.agronomist_area_name.$error.maxlength\">Az adatlap neve maximum 30 karakter hosszú lehet</span>\n" +
    "          </div>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "      <tr ng-class=\"!adatlap.handled_year.selected ? 'required' : ''\">\n" +
    "        <td><span class=\"pgg-bold\">{{fields.handled_year}}</span> <span class=\"pgg-asterisk\">*</span></td>\n" +
    "        <td>\n" +
    "          <ui-select ng-model=\"adatlap.handled_year.selected\" theme=\"selectize\" title=\"Válassza ki az évet\" ng-disabled=\"!userCanEdit\">\n" +
    "            <ui-select-match placeholder=\"{{fields.handled_year}}...\">{{$select.selected.value}}</ui-select-match>\n" +
    "            <ui-select-choices repeat=\"item in adatlap.handled_year | filter: $select.search\">\n" +
    "              <div ng-bind-html=\"item.value | highlight: $select.search\"></div>\n" +
    "            </ui-select-choices>\n" +
    "          </ui-select>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "      <tr ng-class=\"!adatlap.cultivation.selected ? 'required' : ''\">\n" +
    "        <td><span class=\"pgg-bold\">{{fields.cultivation}}</span> <span class=\"pgg-asterisk\">*</span></td>\n" +
    "        <td>\n" +
    "          <ui-select ng-model=\"adatlap.cultivation.selected\" theme=\"selectize\" title=\"Válassza ki a művelési ágat\" ng-disabled=\"!userCanEdit\">\n" +
    "            <ui-select-match placeholder=\"{{fields.cultivation}}...\">{{$select.selected.value}}</ui-select-match>\n" +
    "            <ui-select-choices repeat=\"item in adatlap.cultivation | filter: $select.search\">\n" +
    "              <div ng-bind-html=\"item.value | highlight: $select.search\"></div>\n" +
    "            </ui-select-choices>\n" +
    "          </ui-select>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "      <tr ng-class=\"!adatlap.vegetable.selected ? 'required' : ''\">\n" +
    "        <td><span class=\"pgg-bold\">{{fields.vegetable}}</span> <span class=\"pgg-asterisk\">*</span></td>\n" +
    "        <td>\n" +
    "          <ui-select ng-model=\"adatlap.vegetable.selected\" theme=\"selectize\" title=\"Válasszon termesztett növényt\" ng-disabled=\"!userCanEdit\">\n" +
    "            <ui-select-match placeholder=\"{{fields.vegetable}}...\">{{$select.selected.value}}</ui-select-match>\n" +
    "            <ui-select-choices repeat=\"item in adatlap.vegetable | filter: $select.search\">\n" +
    "              <div ng-bind-html=\"item.value | highlight: $select.search\"></div>\n" +
    "            </ui-select-choices>\n" +
    "          </ui-select>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "      <tr>\n" +
    "        <td><span class=\"pgg-bold\">{{fields.vegetable2}}</span></td>\n" +
    "        <td>\n" +
    "          <ui-select ng-model=\"adatlap.vegetable2.selected\" theme=\"selectize\" title=\"Válasszon másodvetést\" ng-disabled=\"!userCanEdit\">\n" +
    "            <ui-select-match placeholder=\"{{fields.vegetable2}}...\">{{$select.selected.value}}</ui-select-match>\n" +
    "            <ui-select-choices repeat=\"item in adatlap.vegetable2 | filter: $select.search\">\n" +
    "              <div ng-bind-html=\"item.value | highlight: $select.search\"></div>\n" +
    "            </ui-select-choices>\n" +
    "          </ui-select>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "      <tr>\n" +
    "        <td><span class=\"pgg-bold\">{{fields.area_fromgeom}}</span> <span class=\"pgg-plusinfo\">&nbsp;[hektár]</span></td>\n" +
    "        <td><span ng-bind=\"(adatlap.area_fromgeom | number:2)\"></span></td>\n" +
    "      </tr>\n" +
    "      <tr ng-class=\"(adatlapForm.area_size.$dirty && adatlapForm.area_size.$invalid) ? 'required' : ''\">\n" +
    "        <td><span class=\"pgg-bold\">{{fields.area_size}}</span> <span class=\"pgg-plusinfo\">&nbsp;[hektár]</span></td>\n" +
    "        <td><input type=\"text\" name=\"area_size\" ng-model=\"adatlap.area_size.value\" title=\"Írja be a becsült területet hektárban\" ng-pattern=\"/^\\d*\\.?\\d*$/\" placeholder=\"{{fields.area_size}} hektárban...\" ng-disabled=\"!userCanEdit\">\n" +
    "          <span class=\"invalid pgg-smaller pgg-error-paddingtop\" ng-show=\"adatlapForm.area_size.$dirty && adatlapForm.area_size.$invalid\">Hibás számformátum! Helyes érték pl. 12.25</span>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "      <tr>\n" +
    "        <td><span class=\"pgg-bold\">{{fields.saps}}</span></td>\n" +
    "        <td>\n" +
    "          <ui-select ng-model=\"adatlap.saps.selected\" theme=\"selectize\" title=\"Válassza ki a SAPS értékét\" ng-disabled=\"!userCanEdit\">\n" +
    "            <ui-select-match placeholder=\"{{fields.saps}}...\">{{$select.selected.value}}</ui-select-match>\n" +
    "            <ui-select-choices repeat=\"item in adatlap.saps | filter: $select.search\">\n" +
    "              <div ng-bind-html=\"item.value | highlight: $select.search\"></div>\n" +
    "            </ui-select-choices>\n" +
    "          </ui-select>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "      <tr>\n" +
    "        <td><span class=\"pgg-bold\">{{fields.kat_thet}}</span></td>\n" +
    "        <td>\n" +
    "          <ui-select ng-model=\"adatlap.kat_thet.selected\" theme=\"selectize\" title=\"Válassza ki a KAT/THÉT értékét\" ng-disabled=\"!userCanEdit\">\n" +
    "            <ui-select-match placeholder=\"{{fields.kat_thet}}...\">{{$select.selected.value}}</ui-select-match>\n" +
    "            <ui-select-choices repeat=\"item in adatlap.kat_thet | filter: $select.search\">\n" +
    "              <div ng-bind-html=\"item.value | highlight: $select.search\"></div>\n" +
    "            </ui-select-choices>\n" +
    "          </ui-select>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "      <tr>\n" +
    "        <td><span class=\"pgg-bold\">{{fields.akg}}</span></td>\n" +
    "        <td>\n" +
    "          <ui-select ng-model=\"adatlap.akg.selected\" theme=\"selectize\" title=\"Válassza ki az AKG értékét\" ng-disabled=\"!userCanEdit\">\n" +
    "            <ui-select-match placeholder=\"{{fields.akg}}...\">{{$select.selected.value}}</ui-select-match>\n" +
    "            <ui-select-choices repeat=\"item in adatlap.akg | filter: $select.search\">\n" +
    "              <div ng-bind-html=\"item.value | highlight: $select.search\"></div>\n" +
    "            </ui-select-choices>\n" +
    "          </ui-select>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "      <tr>\n" +
    "        <td><span class=\"pgg-bold\">{{fields.emva}}</span></td>\n" +
    "        <td>\n" +
    "          <ui-select ng-model=\"adatlap.emva.selected\" theme=\"selectize\" title=\"Válassza ki a gyepterület támogatás értékét\" ng-disabled=\"!userCanEdit\">\n" +
    "            <ui-select-match placeholder=\"{{fields.emva}}...\">{{$select.selected.value}}</ui-select-match>\n" +
    "            <ui-select-choices repeat=\"item in adatlap.emva | filter: $select.search\">\n" +
    "              <div ng-bind-html=\"item.value | highlight: $select.search\"></div>\n" +
    "            </ui-select-choices>\n" +
    "          </ui-select>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "    </table>\n" +
    "  </form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\" ng-disabled=\"\n" +
    "        adatlapForm.$pristine || \n" +
    "          !(adatlap.handled_year.selected && adatlap.cultivation.selected && adatlap.vegetable.selected) || \n" +
    "          (adatlapForm.area_size.$dirty && adatlapForm.area_size.$invalid) || \n" +
    "          (adatlapForm.agronomist_area_name.$pristine && adatlap.agronomist_area_name.value === null) || \n" +
    "          (adatlapForm.agronomist_area_name.$dirty && adatlapForm.agronomist_area_name.$invalid)\">OK</button>\n" +
    "  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Mégsem</button>\n" +
    "</div>");
}]);

angular.module("../app/print/print.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/print/print.html",
    "<div class=\"pgg-sidebar-item unselectable\">\n" +
    "  <div class=\"pgg-print\">\n" +
    "\n" +
    "    <uib-tabset justified=\"true\">\n" +
    "      <uib-tab index=\"0\">\n" +
    "        <uib-tab-heading>\n" +
    "          <span>TÉRKÉP</span>\n" +
    "        </uib-tab-heading>\n" +
    "        <div class=\"tab-content\">\n" +
    "          <form name=\"printForm\">\n" +
    "            <div>\n" +
    "              <span class=\"pgg-sidebar-item-title\">TÉRKÉP CÍME</span>\n" +
    "              <div class=\"print-input\">\n" +
    "                <input type=\"text\" ng-model=\"params.title\" placeholder=\"Nevezze el a térképet...\">\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "              <span class=\"pgg-sidebar-item-title\">MEGJEGYZÉS</span>\n" +
    "              <div class=\"print-input\">\n" +
    "                <input type=\"text\" ng-model=\"params.comment\" placeholder=\"Adjon a térképhez megjegyzést...\">\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "              <span class=\"pgg-sidebar-item-title\">TÁJOLÁS</span>\n" +
    "              <div class=\"print-dropdown\">\n" +
    "                <ui-select ng-model=\"printInfo.layouts.selected\" theme=\"selectize\" title=\"Válassza ki az elrendezést\">\n" +
    "                  <ui-select-match placeholder=\"Válassza ki az elrendezést...\">{{$select.selected.name}}</ui-select-match>\n" +
    "                  <ui-select-choices repeat=\"item in printInfo.layouts | filter: $select.search\">\n" +
    "                    <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n" +
    "                  </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div ng-show=\"false\">\n" +
    "              <span class=\"pgg-sidebar-item-title\">FELBONTÁS</span>\n" +
    "              <div class=\"print-dropdown\">\n" +
    "                <ui-select ng-model=\"printInfo.dpis.selected\" theme=\"selectize\" title=\"Válassza ki a felbontást\">\n" +
    "                  <ui-select-match placeholder=\"Válassza ki a felbontást...\">{{$select.selected.name}}&nbsp;dpi</ui-select-match>\n" +
    "                  <ui-select-choices repeat=\"item in printInfo.dpis | filter: $select.search\">\n" +
    "                    <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n" +
    "                  </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "              <span class=\"pgg-sidebar-item-title\">MÉRETARÁNY</span>\n" +
    "              <div class=\"print-dropdown\">\n" +
    "                <ui-select ng-model=\"printInfo.scales.selected\" theme=\"selectize\" title=\"Válassza ki a léptéket\" on-select=\"ctrl.selectScale()\">\n" +
    "                  <ui-select-match placeholder=\"Válassza ki a felbontást...\">{{$select.selected.name}}</ui-select-match>\n" +
    "                  <ui-select-choices repeat=\"item in printInfo.scales | filter: $select.search\">\n" +
    "                    <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n" +
    "                  </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "              <span class=\"pgg-sidebar-item-title\">FORMÁTUM</span>\n" +
    "              <div class=\"print-dropdown\">\n" +
    "                <ui-select ng-model=\"printInfo.outputFormats.selected\" theme=\"selectize\" title=\"Válassza ki a formátumot\">\n" +
    "                  <ui-select-match placeholder=\"Válassza ki a formátumot...\">{{$select.selected.name | uppercase}}\n" +
    "                  </ui-select-match>\n" +
    "                  <ui-select-choices repeat=\"item in printInfo.outputFormats | filter: $select.search\">\n" +
    "                    <div ng-bind-html=\"item.name | uppercase | highlight: $select.search\"></div>\n" +
    "                  </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </form>\n" +
    "          <div class=\"print-buttons\">\n" +
    "            <button class=\"btn btn-primary pgg-print-button\" type=\"button\" ng-click=\"ctrl.doPrint()\" ng-disabled=\"!printInfo.layouts.selected || !printInfo.dpis.selected\n" +
    "              || !printInfo.scales.selected || !printInfo.outputFormats.selected\">\n" +
    "              <i class=\"glyphicon glyphicon-print\"></i>&nbsp;\n" +
    "              <span ng-show=\"!printInProgress\">Térkép letöltése</span>\n" +
    "              <span ng-show=\"printInProgress\">\n" +
    "                <i>Kérem várjon...</i>\n" +
    "              </span>\n" +
    "            </button>\n" +
    "           <button class=\"btn btn-primary pgg-print-button\" type=\"button\" ng-click=\"ctrl.doPrintJelmagyarazat()\">\n" +
    "              <i class=\"glyphicon glyphicon-th-list\"></i>&nbsp;\n" +
    "              <span>Jelmagyarázat letöltése (PDF)</span>\n" +
    "            </button>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <hr/>\n" +
    "        <span class=\"pgg-help\">Kimentheti a térkép aktuális nézetét megfelelő méretarányban, tájolásban, illetve formátumban. A térképet el is nevezheti, illetve megjegyzést is fűzhet hozzá. A térkép letöltéséhez engedélyezni kell a felugró ablakokat erről az oldalról.</span>\n" +
    "      </uib-tab>\n" +
    "      <uib-tab index=\"$index+1\" disable=\"!isGazdalkodoiModul\">\n" +
    "        <uib-tab-heading>\n" +
    "          <span>GAZDÁLKODÓI TERV</span>\n" +
    "        </uib-tab-heading>\n" +
    "        <div class=\"tab-content\">\n" +
    "          <span class=\"pgg-sidebar-item-title\">GAZDÁLKODÓI TÁBLÁK</span>\n" +
    "          <div ng-if=\"tablak.length > 0\">\n" +
    "            <table class=\"table-striped print-table\">\n" +
    "              <tbody class=\"pgg-table\">\n" +
    "                <tr ng-repeat=\"t in tablak | orderBy: ['properties.id']\" ng-class=\"t.selected ? 'cursor-pointer pgg-selected' : 'cursor-pointer'\" ng-click=\"ctrl.selectTabla(t)\">\n" +
    "                  <td style=\"width: 30px\">{{$index + 1}}</td>\n" +
    "                  <td>{{t.properties.name}}</td>\n" +
    "                </tr>\n" +
    "              </tbody>\n" +
    "            </table>\n" +
    "            <div class=\"print-buttons\">\n" +
    "              <button class=\"btn btn-default\" ng-click=\"ctrl.selectAllTables()\"><span>Mindegyik kijelölése</span></button>\n" +
    "              <button class=\"btn btn-default\" ng-click=\"ctrl.deselectAllTables()\"><span>Kijelölés megszüntetése</span></button>\n" +
    "            </div>\n" +
    "            <div class=\"print-buttons\">\n" +
    "              <button class=\"btn btn-primary pgg-print-button\" type=\"button\" ng-click=\"ctrl.doPrintTerv()\">\n" +
    "              <i class=\"glyphicon glyphicon-print\"></i>&nbsp;\n" +
    "              <span ng-show=\"!printTervInProgress\">Gazdálkodói terv letöltése</span>\n" +
    "              <span ng-show=\"printTervInProgress\">\n" +
    "                <i>Kérem várjon...</i>\n" +
    "              </span>\n" +
    "            </button>\n" +
    "            </div>\n" +
    "            <hr/>\n" +
    "            <span class=\"pgg-help\">Kimentheti a gazdálkodói tábláira vonatkozó előírásokat. Kattintással jelölje ki a szükséges táblákat!</span>\n" +
    "          </div>\n" +
    "          <div ng-if=\"tablak.length === 0\">\n" +
    "            <span class=\"pgg-help\">Még nem hozott létre gazdálkodó táblát.</span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "    <div class=\"pgg-alerts\">\n" +
    "      <uib-alert ng-repeat=\"alert in alerts\" type=\"{{alert.type}}\" close=\"closeAlert($index)\" dismiss-on-timeout=\"3000\">{{alert.msg}}</uib-alert>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("../app/search/search.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/search/search.html",
    "<div class=\"pgg-search unselectable\">\n" +
    "  <input type=\"text\"\n" +
    "      ng-model=\"selected\"\n" +
    "      uib-typeahead=\"sa.value for sa in searchables | filter: $viewValue:startsWith | orderBy: 'type' | limitTo:8\"\n" +
    "      typeahead-on-select=\"onSelect($item, $model, $label)\"\n" +
    "      typeahead-wait-ms=\"200\"\n" +
    "      typeahead-min-length=\"1\"\n" +
    "      class=\"pgg-search form-control\"\n" +
    "      placeholder=\"Gyorskereső...\"\n" +
    "      title=\"Település és gazdálkodói terület kereső\">\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/sidebar/sidebar_gazdalkodoi.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/sidebar/sidebar_gazdalkodoi.html",
    "<div class=\"pgg-sidebar unselectable\">\n" +
    "  <div class=\"header\">\n" +
    "    <span ng-repeat=\"element in elements\"\n" +
    "        class=\"header-element\">\n" +
    "      <span title=\"{{element.title}}\">\n" +
    "        <img ng-src=\"{{element.icon}}\" class=\"cursor-pointer\" ng-click=\"ctrl.setVisible(element)\">\n" +
    "      </span>\n" +
    "    <span class=\"vertical\"></span>\n" +
    "    </span>\n" +
    "    <span class=\"pgg-sugo\"\n" +
    "        title=\"{{sugo.title}}\">\n" +
    "      <img ng-src=\"{{sugo.icon}}\" class=\"cursor-pointer\" ng-click=\"ctrl.openGazdalkodoiSugo()\">\n" +
    "    </span>\n" +
    "  </div>\n" +
    "  <div class=\"accordion\">\n" +
    "    <pgg-layertree map=\"map\"\n" +
    "        type=\"gazdalkodoi\"\n" +
    "        ng-show=\"layers.visible\"></pgg-layertree>\n" +
    "    <pgg-edit map=\"map\"\n" +
    "        ng-show=\"edit.visible\"></pgg-edit>\n" +
    "    <pgg-measure map=\"map\"\n" +
    "        ng-show=\"measure.visible\"></pgg-measure>\n" +
    "    <pgg-print map=\"map\"\n" +
    "        ng-show=\"print.visible\"></pgg-print>\n" +
    "    <pgg-featureinfo map=\"map\"\n" +
    "        ng-show=\"featureInfo.visible\"></pgg-featureinfo>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/sidebar/sidebar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/sidebar/sidebar.html",
    "<div class=\"pgg-sidebar unselectable\">\n" +
    "  <div class=\"header\">\n" +
    "    <span ng-repeat=\"element in elements\"\n" +
    "        class=\"header-element\">\n" +
    "      <span title=\"{{element.title}}\">\n" +
    "        <img ng-src=\"{{element.icon}}\" class=\"cursor-pointer\" ng-click=\"ctrl.setVisible(element)\">\n" +
    "      </span>\n" +
    "    <span class=\"vertical\"></span>\n" +
    "    </span>\n" +
    "    <span class=\"pgg-sugo\"\n" +
    "        title=\"{{sugo.title}}\">\n" +
    "      <img ng-src=\"{{sugo.icon}}\" class=\"cursor-pointer\" ng-click=\"ctrl.openTerkepSugo()\">\n" +
    "    </span>\n" +
    "  </div>\n" +
    "  <div class=\"accordion\">\n" +
    "    <pgg-layertree map=\"map\"\n" +
    "        type=\"terkep\"\n" +
    "        ng-show=\"layers.visible\"></pgg-layertree>\n" +
    "    <pgg-measure map=\"map\"\n" +
    "        ng-show=\"measure.visible\"></pgg-measure>\n" +
    "    <pgg-print map=\"map\"\n" +
    "        ng-show=\"print.visible\"></pgg-print>\n" +
    "    <pgg-featureinfo map=\"map\"\n" +
    "        ng-show=\"featureInfo.visible\"></pgg-featureinfo>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);
